import angular from 'angular';

import { RestrictInputCharacters } from './resrict-input-characters.directive';

const MODULE_NAME = 'restrictInputCharactersComponent';

export default angular.module(MODULE_NAME, []).directive('restrictInputCharacters', RestrictInputCharacters).name;


